import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/* PWA service worker registration — production builds only.
 *
 * The SW itself is a no-op (see public/service-worker.js): it doesn't
 * cache or intercept anything. Its only job is to satisfy Chrome's
 * installability check so Android users see the automatic "Add to
 * Home Screen" prompt. iOS Safari's Add-to-Home-Screen flow doesn't
 * need this and works on the manifest alone.
 *
 * Guards:
 *   • production builds only (avoids dev-server hot-reload weirdness)
 *   • feature-detected — falls through silently on unsupported browsers
 *   • registration failures are swallowed; PWA is purely additive
 */
if (
  process.env.NODE_ENV === "production" &&
  typeof window !== "undefined" &&
  "serviceWorker" in navigator
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // Non-fatal — the app continues to work as a regular SPA. We
        // intentionally don't toast/log to PostHog: a SW registration
        // failure is operationally equivalent to "no PWA install
        // prompt today" — not a user-visible bug.
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("[PayGBot] SW registration skipped:", err?.message);
        }
      });
  });
}
